import React from 'react'

export default function Lsb() {
  return (
        <div className="left-sidebar">
            <div className="sidebar-header d-flex align-items-center justify-content-between">
                <img src="https://files.tryhard.cloud/s/MLWCr6oZi4m6LDt/preview" alt="Logo"/>
            </div>
            <h2 className="email">Inquiries.Tryhard@gmail.com</h2>
            <h2 className="address">Based in Tallinn, Estonia</h2>
            <p className="copyright">&copy; 2025 Tryhard. All Rights Reserved</p>
            <ul className="social-profile d-flex align-items-center flex-wrap justify-content-center">
                <li>
                    <a href="https://twitter.com/TryhardRust"><i className="lab la-twitter"></i></a>
                </li>
                <li>
                    <a href="https://github.com/Tryhard999"><i className="lab la-github"></i></a>
                </li>
            </ul>
            <a href="https://discord.gg/YnbYaugRMh" className="theme-btn">
    <i></i> Discord
</a>
        </div>
  )
}   
